import { lazy } from "react";
import { ALLOWED_MODULES } from "../../constants/enums";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";
import { MANAGE_MEMBERSHIP_ROUTE } from "./manageMembership.constant";

const ManageMembership = Loadable(
	lazy(() =>
		import("./manageMembership").then(({ ManageMembership }) => ({
			default: ManageMembership,
		}))
	)
);

export const manageMembershipRoutes = [
	{
		path: MANAGE_MEMBERSHIP_ROUTE,
		exact: true,
		element: (
			<AuthorizedRoute
				allowFullAccess={true}
				moduleIds={[]}
			>
				<ManageMembership />
			</AuthorizedRoute>
		),
	},
];
